"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SidebarContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = _interopRequireDefault(require("../modal"));

var _sidebar = _interopRequireDefault(require("./sidebar.style"));

var _iconButton = _interopRequireDefault(require("../icon-button"));

var _icon = _interopRequireDefault(require("../icon"));

var _focusTrap = _interopRequireDefault(require("../../__internal__/focus-trap"));

var _sidebarHeader = _interopRequireDefault(require("./__internal__/sidebar-header"));

var _box = _interopRequireDefault(require("../box"));

var _sidebar2 = require("./sidebar.config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SidebarContext = /*#__PURE__*/_react.default.createContext({});

exports.SidebarContext = SidebarContext;

const Sidebar = /*#__PURE__*/_react.default.forwardRef(({
  open,
  disableEscKey,
  enableBackgroundUI,
  header,
  position,
  size,
  children,
  onCancel,
  ...rest
}, ref) => {
  const sidebarRef = ref || (0, _react.useRef)();

  const closeIcon = () => {
    if (!onCancel) return null;
    return /*#__PURE__*/_react.default.createElement(_iconButton.default, {
      "aria-label": "close",
      onAction: onCancel,
      "data-element": "close"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "close"
    }));
  };

  const componentTags = {
    "data-component": "sidebar",
    "data-element": rest["data-element"],
    "data-role": rest["data-role"]
  };

  const sidebar = /*#__PURE__*/_react.default.createElement(_sidebar.default, {
    ref: sidebarRef,
    position: position,
    size: size,
    "data-element": "sidebar",
    role: "complementary",
    onCancel: onCancel
  }, closeIcon(), header && /*#__PURE__*/_react.default.createElement(_sidebarHeader.default, null, header), /*#__PURE__*/_react.default.createElement(_box.default, {
    "data-element": "sidebar-content",
    p: 4,
    pt: "27px",
    scrollVariant: "light",
    overflow: "auto"
  }, /*#__PURE__*/_react.default.createElement(SidebarContext.Provider, {
    value: {
      isInSidebar: true
    }
  }, children)));

  return /*#__PURE__*/_react.default.createElement(_modal.default, _extends({
    open: open,
    onCancel: onCancel,
    disableEscKey: disableEscKey,
    enableBackgroundUI: enableBackgroundUI,
    className: "carbon-sidebar"
  }, componentTags), enableBackgroundUI ? sidebar : /*#__PURE__*/_react.default.createElement(_focusTrap.default, {
    wrapperRef: sidebarRef
  }, sidebar));
});

Sidebar.propTypes = {
  /** Modal content */
  children: _propTypes.default.node,

  /** A custom close event handler */
  onCancel: _propTypes.default.func,

  /** Determines if the Esc Key closes the modal */
  disableEscKey: _propTypes.default.bool,

  /** A boolean to track the open state of the dialog */
  open: _propTypes.default.bool.isRequired,

  /** Set this prop to false to hide the translucent background when the dialog is open. */
  enableBackgroundUI: _propTypes.default.bool,

  /** Sets the position of sidebar, either left or right. */
  position: _propTypes.default.oneOf(_sidebar2.SIDEBAR_ALIGNMENTS),

  /** Sets the size of the sidebar when open. */
  size: _propTypes.default.oneOf(_sidebar2.SIDEBAR_SIZES),

  /** Node that will be used as sidebar header. */
  header: _propTypes.default.node
};
Sidebar.defaultProps = {
  position: "right",
  size: "medium",
  enableBackgroundUI: false
};
var _default = Sidebar;
exports.default = _default;